import { Box } from "@mui/material";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";

import { useEffect, useState } from "react";
import { fetchDataEngine } from "../../../data/Axios/DynamicService";

import {
  allImprestSurrender,
  imprestApplications,
  leaveApplications,
  leaveApplicationsByUser,
} from "../../../data/Queries/HRmanagement/leavemanagement";
import {
  AllImprestSurrenderColumns,
  LeaveApplicationsColumns,
  imprestApplicationsColumns,
  imprestSurrenderLinesColumns,
} from "../../../data/Columns/hrmanagement";
import { HRService } from "../../../config";
import LeaveApplicationForm from "./form";
import ImprestSurrenderForm from "./form";
import SurrenderLineForm from "./surrenderLineForm";

function ImprestSurrenderLineTable() {
  const data = JSON.parse(localStorage.getItem("SurrenderId"));
  const base_url = HRService.uri;
  const actions = {
    entity: "Imprest Surrender",

    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: false,
      permission: "EditPermission",
    },
    add: {
      key: "ADD",
      button_name: "Add",
      Show_Button: true,
      permission: "CreatePermission",
    },
    activateDeactivate: {
      key: "ACTIVATEDEACTIVATE",
      button_name: "Deactivate",
      Show_Button: false,
      permission: "ActivatePermission",
    },

    removeSurrenderLine: {
      key: "REMOVE_RELIEVER",
      button_name: "Remove Line",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2],
    },
    dataObjectForMutation: {
      isSurrenderLine: true,
      inputObjectName: "addRemoveImprestSurrenderLines",
      inputSubObjectName: "lines",
      inputFields: ["applicationId", "userId", "comments"],
      actionName: "Leave Application ",
    },

    dataObject: {
      inputFields: {
        surrenderId: data ? data.id : null,
      },
      inputObjectName: "imprestSurrenderLinesByApplicationOrSurrenderId",
      inputSubObjectName: "surrenderLines",
      returnFields: [
        "id",
        "surrenderId",
        "applicationId",
        "description",
        "amount",
      ],
    },
    showStatus: true,
  };
  return (
    <Box m="2px">
      <>
        <DynamicTable
          title="Imprest Surrender Lines"
          subtitle="View all imprest Surrenderrs, add or remove"
          columns={imprestSurrenderLinesColumns}
          FormComponent={SurrenderLineForm}
          //  query={allImprestSurrender}
          actions={actions}
          base_url={base_url}
        />
      </>
    </Box>
  );
}

export default ImprestSurrenderLineTable;
